module.exports = __webpack_public_path__ + "img/Sendmagic.45311463.png";